import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'compactNumberFormat'
})
export class CompactNumberFormatPipe implements PipeTransform {

  transform(
    value: any,
    minOffset: number = 1,
    minDigitsInfo: string = '0.2-10',
    maxOffset: number = 1000,
    maxDigitsInfo: string = '0.2-2',
    maximumFractionDigits: number = 1,
    locale: string = 'en',
    ...args: unknown[]
  ): unknown {

    const input = Number(value);

    if (Number.isNaN(input)) {
      return null;
    }

    if (input < minOffset) {
      return formatNumber(input, locale, minDigitsInfo);
    }

    if (input < maxOffset) {
      return formatNumber(input, locale, maxDigitsInfo);
    }

    return new Intl.NumberFormat(locale, {
      style: 'decimal',
      //@ts-ignore
      notation: 'compact',
      maximumFractionDigits,
    }).format(input);
  }

}
